import React from "react";
import { API } from "../lib/api";

// Live in-app maintenance page: renders the exact same self-contained page the backend serves.
export default function MaintenancePage() {
  return (
    <div style={{ position: "fixed", inset: 0 }} data-testid="maintenance-page">
      <iframe title="Scheduled Maintenance" src={`${API}/maintenance/page.html`}
        style={{ width: "100%", height: "100%", border: "none" }} />
    </div>
  );
}
